import './styles/index.scss'
import elvtheme from './scripts/index.ts'

elvtheme() 
